import { useContext, useEffect, useState } from "react";
import { FieldValues, useForm } from "react-hook-form";
import CustomInput from "../../../components/inputs/CustomInput";
import FileInput from "../../../components/inputs/FileInput";
import SwitchInput from "../../../components/inputs/SwitchInput";
import MyNavigator from "../../../components/misc/MyNavigator";
import NavBar from "../../../components/misc/NavBar";
import SideBar from "../../../components/misc/SideBar";
import DeleteModal from "../../../components/modals/DeleteModal";
import { editInputs } from "../../../consts/inputs";
import { toIcons } from "../../../consts/Paths";
import MainContext from "../../../context/MainContext";
import useLoader from "../../../hooks/useLoader";
import useIsMobile from "../../../hooks/useIsMobile";
import useToggle from "../../../hooks/useToggle";
import { Input, Model } from "../../../interfaces";
import "../../../styles/Edit.css";
import { backToTopOfPage } from "../../../utils/others";
import { getDefaultValue, getInputs } from "../../../utils/getMethods";
import { formatDateYYYMMGG } from "../../../utils/reformatDate";
import useModels from "../../../api/hooks/useModels";
import useLogMessage from "../../../hooks/useLogMessage";
import LogMessage from "../../../components/misc/LogMessage";
import { logMsgBgColors } from "../../../consts/misc";
import {
  modelRemappingFromEditInputs,
  modelRemappingFromResult,
} from "../../../utils/modelRemapping";

const ModelEditPage = (props: any) => {
  const { isMobile } = useIsMobile();
  const navigateNow = useToggle(false);
  const navigateToModelsNow = useToggle(false);
  const menuToggler = useToggle(false);
  const { model, setModel, refresh, setRefresh } =
    useContext(MainContext);
  const onCreateModel = model === null;
  const { RESPONSES, RESULTS, CTAs } = useModels();
  const tempLoading = useToggle(false);
  const logMessage = useLogMessage();
  const profileImageLoader = useLoader(model, refresh);
  const photosLoader = useLoader(model, refresh);
  const polaroidsLoader = useLoader(model, refresh);
  const videosLoader = useLoader(model, refresh);
  const documentsLoader = useLoader(model, refresh);

  /* Modal */
  const deleteModalToggler = useToggle(false);
  /* Forms */
  const deleteModelForm = useForm();
  const edit_create_ModelForm = useForm();

  useEffect(() => {
    if (deleteModalToggler.isToggled) {
      backToTopOfPage();
    }
  }, [deleteModalToggler]);

  useEffect(() => {
    if (model) {
      tempLoading.setIsToggled(true);
      CTAs.getModelById(model.id);
    }
  }, [refresh]);

  useEffect(() => {
    /* console.log(RESPONSES.getByIdResponse, RESULTS.getByIdResult);   */
    if (RESPONSES.getByIdResponse?.ok) {
      tempLoading.setIsToggled(false);
      const remappedModel = modelRemappingFromResult(
        RESULTS.getByIdResult?.model
      );
      setModel(remappedModel);
    }
  }, [RESPONSES.getByIdResponse]);

  useEffect(() => {
    if (tempLoading.isToggled) {
      /* caricamento */
      logMessage.setMessageTimer(20000);
      logMessage.write("subject", "Loading . . .");
      logMessage.write("bgColor", logMsgBgColors.loading);
    } else if (!tempLoading.isToggled) {
      logMessage.setMessageTimer(null);
    }
  }, [tempLoading.isToggled]);

  useEffect(() => {
    if (model) {
      edit_create_ModelForm.reset(model);
    }
  }, [model]);

  const handleAction = (data: any) => {
    if (onCreateModel) {
      onCreateModelSubmit(data);
    } else {
      onEditModelSubmit(data);
    }
  };

  const onEditModelSubmit = (data: any) => {
    tempLoading.setIsToggled(true);
    /* console.log("calling edit model"); */
    const profileImage = profileImageLoader.filesBase64[0]?.profileImage;
    const photos = photosLoader.filesBase64;
    const polaroids = polaroidsLoader.filesBase64;
    const videos = videosLoader.filesBase64;
    const documents = documentsLoader.filesBase64;
    const finalObj = modelRemappingFromEditInputs(
      data,
      profileImage,
      photos,
      polaroids,
      videos,
      documents
    );
    /* console.log(  finalObj,  console.log(JSON.stringify(finalObj)));   */  
    if (model) {
       CTAs.updateModels(model?.id, finalObj);  
    }
  };
  useEffect(() => {
    /*  console.log(RESPONSES.updateResponse, RESULTS.updateResult);   */
    if (RESPONSES.updateResponse?.ok === true) {
      /* 
      tempLoading.setIsToggled(false); */
      logMessage.write("subject", "Model");
      logMessage.write("other_text", " was updated succesffuly!");
      logMessage.write("bgColor", logMsgBgColors.correct);
      setRefresh((prevState) => !prevState);
      /* setTimeout(() => {
        navigateNow.toggle();
      }, 3000); */
    } else if (RESPONSES.updateResponse?.ok === false) {
      /* 
      tempLoading.setIsToggled(false); */
      logMessage.write("subject", "Model");
      logMessage.write("other_text", " not updated!");
      logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [RESPONSES.updateResponse]);

  const onDeleteModelSubmit = (data: any) => {
    if (model) {
      tempLoading.setIsToggled(true);
      CTAs.deleteModels(model?.id);
    }
  };
  useEffect(() => {
    /*  console.log(RESPONSES.deleteResponse, RESULTS.deleteResult); */
    if (RESPONSES.deleteResponse?.ok === true) {
      /* 
      tempLoading.setIsToggled(false); */
      logMessage.write("subject", "Model");
      logMessage.write("other_text", " was deleted succesffuly!");
      logMessage.write("bgColor", logMsgBgColors.correct);
      deleteModalToggler.toggle();
      setRefresh((prevState) => !prevState);
      setTimeout(() => {
        navigateToModelsNow.toggle();
      }, 3000);
    } else if (RESPONSES.deleteResponse?.ok === false) {
      /* 
      tempLoading.setIsToggled(false); */
      logMessage.write("subject", "Model");
      logMessage.write("other_text", " not deleted!");
      logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [RESPONSES.deleteResponse]);

  const onCreateModelSubmit = (data: any) => {
    /* console.log(data) */
    tempLoading.setIsToggled(true);
    /* console.log(data, "create model"); */
    const profileImage = profileImageLoader.filesBase64[0]?.profileImage;
    const photos = photosLoader.filesBase64;
    const polaroids = polaroidsLoader.filesBase64;
    const videos = videosLoader.filesBase64;
    const documents = documentsLoader.filesBase64;
    const finalObj = modelRemappingFromEditInputs(
      data,
      profileImage,
      photos,
      polaroids,
      videos,
      documents
    );
    /* console.log(finalObj, console.log(JSON.stringify(finalObj))); */
    CTAs.createModels(finalObj);
  };
  useEffect(() => {
    /* console.log(RESPONSES.createResponse, RESULTS.createResult); */
    if (RESPONSES.createResponse?.ok === true) {
      tempLoading.setIsToggled(false);
      logMessage.write("subject", "Model");
      logMessage.write("other_text", " was created succesffuly!");
      logMessage.write("bgColor", logMsgBgColors.correct);
      setRefresh((prevState) => !prevState);
      setTimeout(() => {
        navigateNow.toggle();
      }, 3000);
    } else if (RESPONSES.createResponse?.ok === false) {
      tempLoading.setIsToggled(false);
      logMessage.write("subject", "Model");
      logMessage.write("other_text", " not created!");
      logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [RESPONSES.createResponse]);

  const handleOnClickDelete = () => {
    deleteModalToggler.toggle();
  };

  const bio_Inputs = getInputs(editInputs, ["bio"]);
  const render_bio_Inputs = bio_Inputs[0].fields!.map(
    (item: Input, key: number) => {
      let defaultValue: string | number | Date = getDefaultValue(
        model?.bio!,
        item
      );
      if (item.type === "select") {
        return (
          <CustomInput
            width={isMobile ? 305 : 573}
            key={key}
            {...item}
            register={edit_create_ModelForm.register}
            errors={edit_create_ModelForm.formState.errors}
            options={item.fields}
            defaultValue={defaultValue}
          />
        );
      } else
        return (
          <CustomInput
            width={isMobile ? 280 : item.type === "Date" ? 570 : 544}
            key={key}
            {...item}
            register={edit_create_ModelForm.register}
            errors={edit_create_ModelForm.formState.errors}
            defaultValue={
              item.type === "Date"
                ? formatDateYYYMMGG(new Date(defaultValue))
                : defaultValue
            }
          />
        );
    }
  );

  const contacts_Inputs = getInputs(editInputs, ["contacts"]);
  const render_contacts_Inputs = contacts_Inputs[0].fields!.map(
    (item: Input, key: number) => {
      let defaultValue: string | number | Date = getDefaultValue(
        model?.contacts!,
        item
      );
      return (
        <CustomInput
          width={isMobile ? 280 : 543}
          key={key}
          {...item}
          register={edit_create_ModelForm.register}
          errors={edit_create_ModelForm.formState.errors}
          defaultValue={defaultValue}
        />
      );
    }
  );

  const socials_inputs = getInputs(editInputs, ["socials"]);
  const render_socials_inputs = socials_inputs[0].fields!.map(
    (item: Input, key: number) => {
      const facebook = model?.contacts?.socials?.facebook.link;
      const instagram = model?.contacts?.socials?.instagram.link;
      const tiktok = model?.contacts?.socials?.tiktok.link;
      let defaultValue: string = "";
      if (item.name === "facebook") {
        defaultValue = facebook!;
      }
      if (item.name === "instagram") {
        defaultValue = instagram!;
      }
      if (item.name === "tiktok") {
        defaultValue = tiktok!;
      }
      return (
        <CustomInput
          width={isMobile ? 280 : 543}
          key={key}
          {...item}
          register={edit_create_ModelForm.register}
          errors={edit_create_ModelForm.formState.errors}
          defaultValue={defaultValue}
        />
      );
    }
  );

  const mesurements_inputs = getInputs(editInputs, ["mesurements"]);
  const render_mesurements_inputs = mesurements_inputs[0].fields!.map(
    (item: Input, key: number) => {
      let defaultValue: string | number | Date = getDefaultValue(
        model?.measures!,
        item
      );
      return (
        <span
          key={key}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2px",
            width: "fit-content",
          }}
        >
          <CustomInput
            width={isMobile ? 245 : 220}
            {...item}
            register={edit_create_ModelForm.register}
            errors={edit_create_ModelForm.formState.errors}
            defaultValue={defaultValue}
          />
          {item.name !== "shoes" && (
            <p
              className="unit"
              style={{ margin: isMobile ? "10% 0 0 5px" : "10% 0 0 10px" }}
            >
              cm
            </p>
          )}
        </span>
      );
    }
  );

  const hairs_eyes = getInputs(editInputs, ["hairs_eyes"]);
  const render_hairs_eyes = hairs_eyes[0].fields!.map(
    (item: Input, key: number) => {
      let defaultValue: string | number | Date = getDefaultValue(
        model?.measures!,
        item
      );
      let options: Input[] | undefined = [];
      if (item.name === "eyes") {
        let eyes = item.fields;
        options = eyes;
      } else if (item.name === "hair") {
        let hair = item.fields;
        options = hair;
      }
      return (
        <CustomInput
          width={isMobile ? 305 : 290}
          key={key}
          {...item}
          register={edit_create_ModelForm.register}
          errors={edit_create_ModelForm.formState.errors}
          options={options}
          defaultValue={defaultValue}
        />
      );
    }
  );

  const skills_inputs = getInputs(editInputs, ["skills"]);
  const render_skills_inputs = skills_inputs[0].fields!.map(
    (item: Input, key: number) => {
      let defaultValue: string | number | Date = getDefaultValue(
        model?.skills!,
        item
      );
      return (
        <CustomInput
          width={isMobile ? 305 : 290}
          key={key}
          {...item}
          register={edit_create_ModelForm.register}
          errors={edit_create_ModelForm.formState.errors}
          setValue={edit_create_ModelForm.setValue}
          defaultValue={defaultValue}
        />
      );
    }
  );

  const getModelId = () => {
    if (onCreateModel) {
      return "";
    } else {
      const pathname = window.location.pathname;
      const s = pathname.substring(0, pathname.lastIndexOf("/"));
      const idPath = s.substring(s.lastIndexOf("/", s.length));
      return idPath;
    }
  };

  return (
    <div className="page-wrapper">
      {deleteModalToggler.isToggled && (
        <form onSubmit={deleteModelForm.handleSubmit(onDeleteModelSubmit)}>
          <DeleteModal
            toggler={deleteModalToggler}
            register={deleteModelForm.register}
            reset={deleteModelForm.reset}
            model={model}
            deleteType={"model"}
          />
        </form>
      )}
      <MyNavigator path={`/models${getModelId()}`} trigger={navigateNow} />
      <MyNavigator path={`/models`} trigger={navigateToModelsNow} />
      {(!isMobile || menuToggler.isToggled) && (
        <SideBar toggler={menuToggler} />
      )}
      <div>
        {isMobile && <NavBar toggler={menuToggler} />}
        <div
          className={`page-content ${
            isMobile && menuToggler.isToggled
              ? menuToggler.isToggledSecondary
                ? "slide-right"
                : "slide-left"
              : ""
          }`}
          style={{
            maxWidth: isMobile ? "" : "calc(100vw - 256px)",
            minWidth: isMobile ? "" : "767px",
            marginLeft: isMobile
              ? menuToggler.isToggled
                ? "256px"
                : ""
              : "256px",
            display: deleteModalToggler.isToggled && isMobile ? "none" : "",
          }}
        >
          {logMessage.isToggled && (
            <LogMessage
              text={{
                subject: logMessage.message.subject,
                other_text: logMessage.message.other_text,
                complement: logMessage.message.complement,
              }}
              bgColor={logMessage.message.bgColor}
            />
          )}
          <div
            className="edit-header"
            style={{
              margin: isMobile ? "30px auto 0" : "",
              width: "90%",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            {!onCreateModel && (
              <div
                className="Oval"
                onClick={() => navigateNow.setIsToggled(true)}
              >
                <img src={`${toIcons}/small-left.svg`} />
              </div>
            )}

            <p
              className="edit-header-title"
              style={{
                fontSize: isMobile ? "32px" : "",
                width: onCreateModel ? "" : "70%",
              }}
            >
              {onCreateModel ? "Create new model" : "Edit Profile"}{" "}
            </p>
          </div>

          <form
            onSubmit={edit_create_ModelForm.handleSubmit(handleAction)}
            /* onChange={() =>
            setEditedFieldValues(edit_create_ModelForm.getValues())
          } */
          >
            <div
              className="edit-box1 shadow"
              style={{
                width: isMobile ? "345px" : "",
                padding: isMobile ? "0" : "",
              }}
            >
              {profileImageLoader.filesPreviewSrc[0] ? (
                <div
                  className="profile-img-preview shadow"
                  style={{
                    backgroundImage: `url(${profileImageLoader.filesPreviewSrc[0]})`,
                  }}
                />
              ) : model?.profileImageSrc ? (
                <div
                  className="profile-img-preview shadow"
                  style={{
                    backgroundImage: `url(${model?.profileImageSrc})`,
                  }}
                />
              ) : (
                <div className="media-input-box">
                  <p
                    className="media-input-text"
                    style={{
                      height: "43px",
                      margin: "49px 40px 0px",
                    }}
                  >
                    Upload pofile image
                  </p>
                  <label
                    className="media-input-button"
                    style={{
                      margin: "16px 0 0",
                    }}
                    htmlFor="profile_img_input"
                  >
                    <p className="media-input-button-text">Add image</p>
                  </label>
                </div>
              )}
              <input
                id="profile_img_input"
                type="file"
                accept={"image/*"}
                /* {...edit_create_ModelForm.register("profile_image")} */
                style={{ display: "none" }}
                onChange={(e: any) => {
                  profileImageLoader.process(e, "profileImage");
                }}
              />
              {(profileImageLoader.filesPreviewSrc[0] ||
                model?.profileImageSrc) && (
                <label htmlFor="profile_img_input">
                  <p className="change-image">Change image</p>
                </label>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                <p className="box-title">Personal Information</p>
                {render_bio_Inputs}
              </div>
            </div>
            <div
              className="edit-box2 shadow"
              style={{ width: isMobile ? "345px" : "" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "21px",
                }}
              >
                <p className="box-title">Contacts</p>
                {render_contacts_Inputs}
                <p className="customInputText-title">Social</p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "25px",
                  }}
                >
                  {render_socials_inputs}
                </div>
              </div>
            </div>
            <div
              className="edit-box3 shadow"
              style={{
                width: isMobile ? "345px" : "",
                padding: isMobile ? "41px 0 63px 0" : "",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                <p className="box-title">Mesurements</p>
                <div
                  className="grid"
                  style={{
                    display: isMobile ? "flex" : "grid",
                    flexDirection: isMobile ? "column" : "row",
                    gap: isMobile ? "10px" : "",
                  }}
                >
                  {render_mesurements_inputs}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    gap: isMobile ? "10px" : "20px",
                  }}
                >
                  {render_hairs_eyes}
                </div>
              </div>
            </div>

            {/* skills mvp 2 */}
            {/* <div
              className="edit-skills-box shadow"
              style={{
                width: isMobile ? "345px" : "",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                  alignItems: "center",
                }}
              >
                <p
                  className="box-title"
                  style={{
                    marginLeft: isMobile ? "" : "25px",
                    width: isMobile ? "85%" : "86%",
                  }}
                >
                  Skills
                </p>
                <div
                  className="grid"
                  style={{
                    width: isMobile ? "" : "90%",
                    display: isMobile ? "flex" : "grid",
                    flexDirection: isMobile ? "column" : "row",
                    gap: isMobile ? "10px" : "",
                  }}
                >
                  {render_skills_inputs}
                </div>
              </div>
            </div> */}
            {/*  */}

            <div
              className="edit-box4 shadow"
              style={{
                width: isMobile ? "345px" : "",
                padding: isMobile ? "0" : "",
              }}
            >
              <FileInput
                id={"photos_input"}
                name={"photos"}
                type={"file"}
                subType={"photo"}
                title={"Photos"}
                description={"Upload photo"}
                buttonText={"Add"}
                multiple={true}
                accept={".png,.jpg,.jpeg,.gif"}
                register={edit_create_ModelForm.register}
                errors={edit_create_ModelForm.formState.errors}
                onChange={photosLoader.process}
                remove={photosLoader.remove}
                loader={photosLoader}
                links={model?.portfolio?.photos}
              />
            </div>
            <div
              className="edit-box5 shadow"
              style={{
                width: isMobile ? "345px" : "",
                padding: isMobile ? "0" : "",
              }}
            >
              <FileInput
                id={"polaroids_input"}
                name={"polaroids"}
                type={"file"}
                subType={"polaroid"}
                title={"Polaroids"}
                description={"Upload polaroid"}
                buttonText={"Add"}
                multiple={true}
                accept={".png,.jpg,.jpeg,.gif"}
                register={edit_create_ModelForm.register}
                errors={edit_create_ModelForm.formState.errors}
                onChange={polaroidsLoader.process}
                remove={polaroidsLoader.remove}
                loader={polaroidsLoader}
                links={model?.portfolio?.polaroids}
              />
            </div>
            <div
              className="edit-box6 shadow"
              style={{
                width: isMobile ? "345px" : "",
                padding: isMobile ? "0" : "",
              }}
            >
              <FileInput
                id={"videos_input"}
                name={"videos"}
                type={"file"}
                subType={"video"}
                title={"Videos"}
                description={"Upload video"}
                buttonText={"Add"}
                multiple={true}
                accept={".mp4,.mov,.wmv,.avi,.mpeg,"}
                register={edit_create_ModelForm.register}
                errors={edit_create_ModelForm.formState.errors}
                onChange={videosLoader.process}
                remove={videosLoader.remove}
                loader={videosLoader}
                links={model?.portfolio?.videos}
              />
            </div>
            <div
              className="question-line-box"
              style={{ width: isMobile ? "345px" : "" }}
            >
              <p className="question-line-text">
                Has the model signed the resolution relating the use of medias?
              </p>
              <SwitchInput
                name={"media_resolution"}
                register={edit_create_ModelForm.register}
                errors={edit_create_ModelForm.formState.errors}
                watch={edit_create_ModelForm.watch}
              />
            </div>
            <div
              className="edit-box7 shadow"
              style={{ width: isMobile ? "345px" : "" }}
            >
              <FileInput
                id={"documents_input"}
                name={"documents"}
                type={"file"}
                subType={"document"}
                title={"Documents"}
                accept={"application/pdf"}
                multiple={true}
                buttonText={"Add pdf"}
                register={edit_create_ModelForm.register}
                errors={edit_create_ModelForm.formState.errors}
                onChange={documentsLoader.process}
                remove={documentsLoader.remove}
                loader={documentsLoader}
                links={model?.portfolio?.documents}
              />
            </div>
            <div
              className="edit-bottom-cta-box"
              style={{
                flexDirection: isMobile ? "column" : "row",
                width: isMobile ? "345px" : "",
                marginTop: isMobile ? "46px" : "",
                gap: isMobile ? "29px" : "",
                justifyContent: onCreateModel ? "right" : "space-between",
              }}
            >
              {!onCreateModel && (
                <div className="delete-model-box">
                  <img
                    className="delete-model-icon offLightBlue"
                    src={`${toIcons}/delete.svg`}
                  />
                  <p
                    className="delete-model-text offLightBlue"
                    onClick={handleOnClickDelete}
                  >
                    Delete model
                  </p>
                </div>
              )}
              <button
                className="button1"
                style={{ width: isMobile ? "345px" : "101px" }}
                type="submit" /* 
              disabled={ctaToggler.isToggled} */
              >
                <p className="button1-text">
                  {onCreateModel ? "Create" : "Save"}
                </p>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default ModelEditPage;
